<template>
  <Popover class="relative atom tool-tip-button">
    <PopoverButton>
      <div class="flex items-center justify-center p-2 group">
        <span
          class="flex items-center justify-center w-4 h-4 text-xs font-semibold text-white rounded-full font-arial bg-bc-dark-blue group-hover:bg-bc-dark-blue/80"
        >
          <slot name="button"> ? </slot>
        </span>
      </div>
    </PopoverButton>

    <PopoverPanel class="absolute z-10">
      <p
        class="max-w-xs min-w-[200px] p-2 text-center text-white border border-gray-200 rounded bg-bc-dark-blue relative -left-[85%] 2xl:static 2xl:left-0"
      >
        <slot>Here's some tooltip info.</slot>
      </p>
    </PopoverPanel>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
</script>
